import { Indication } from '@abiglobalhealth/go-types'
import { useContext } from 'react'

import { SurveysContext, SurveysContextProps } from '@/contexts/indications'

interface UseIndicationsProps {
  indications: SurveysContextProps['indications']
  addIndication: (indication: Indication) => void
  removeIndication: (indication: Indication) => void
  getIndicationById: (id: Indication['id']) => Indication | undefined
  removeUntilStep: (_: string) => void
  clearIndications: () => void
}

export const useIndications = (): UseIndicationsProps => {
  const { indications, setIndications } = useContext(SurveysContext)

  const addIndication = (indication: Indication) => {
    setIndications((prev) => {
      const currentIndication = prev.find((i) => i.id === indication.id)
      let newIndication: Indication
      if (currentIndication) {
        newIndication = {
          ...currentIndication,
          answers: indication.answers
        }
      } else {
        newIndication = indication
      }

      return [...prev.filter((i) => i.id !== newIndication.id), newIndication]
    })
  }

  const removeIndication = (indication: Indication) => {
    setIndications(indications.filter((i) => i.id !== indication.id))
  }

  const removeUntilStep = (id: string) => {
    const index = indications.findIndex((indication) => indication.id === id)
    if (index === -1) return
    setIndications(indications.slice(0, index + 1))
  }

  const getIndicationById = (id: Indication['id']) => {
    return indications.find((indication) => indication.id === id)
  }

  const clearIndications = () => {
    setIndications([])
  }

  return {
    indications,
    addIndication,
    removeIndication,
    getIndicationById,
    removeUntilStep,
    clearIndications
  }
}
